module.exports = __webpack_public_path__ + "img/bg.b60486e9.png";